const userRoleColumns = [
	{ field: 'roleName', header: 'Role Name' },
	{ field: 'roleDescription', header: 'Role Description' },
	{ field: 'createdBy', header: 'Created By' },
];

export default userRoleColumns;
